import { render, staticRenderFns } from "./speedSetting.vue?vue&type=template&id=5bbfbf53&scoped=true"
import script from "./speedSetting.vue?vue&type=script&lang=js"
export * from "./speedSetting.vue?vue&type=script&lang=js"
import style0 from "./speedSetting.vue?vue&type=style&index=0&id=5bbfbf53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfbf53",
  null
  
)

export default component.exports